import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/_services/user.service';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'telio-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit,OnDestroy {

  supportDetails: any;
  subscription: Subscription = new Subscription;
  constructor(private userservice: UserService, readonly userInfoService: UserInfoService) { 
  }
  
  ngOnInit(): void {
    this.getFooterData()
  }
  getFooterData(){
    const tenantID = this.userInfoService.userDetails.tenantID || 'TELIOEV';
    this.subscription.add(this.userservice.getBrandInfoByTenantId(tenantID).subscribe((res:any)=>{
      this.supportDetails=res;
    },
    error =>{
      this.supportDetails = "";
    }))
  }
  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }
}
